export enum FeeTypeEnum {
  UNKNOWN = 0,
  CAFLER_FEE = 1,
  FIXED_TIME = 2,
  URGENCY = 3,
  INTERNAL_REFUELING_TOPPING_ADDITIONAL_FEE = 100,
}

const FEE_PREFIX = 'common.fee_type.';

export const FeeTypeLabel: Record<FeeTypeEnum, string> = {
  [FeeTypeEnum.UNKNOWN]: `${FEE_PREFIX}UNKNOWN`,
  [FeeTypeEnum.CAFLER_FEE]: `${FEE_PREFIX}CAFLER_FEE`,
  [FeeTypeEnum.FIXED_TIME]: `${FEE_PREFIX}FIXED_TIME`,
  [FeeTypeEnum.URGENCY]: `${FEE_PREFIX}URGENCY`,
  [FeeTypeEnum.INTERNAL_REFUELING_TOPPING_ADDITIONAL_FEE]:
    `${FEE_PREFIX}INTERNAL_REFUELING_TOPPING_ADDITIONAL_FEE`,
};

